import { createFileRoute, useParams } from '@tanstack/react-router';

import { BusinessAssociateEditScreen } from '@/features/business-associates/components/platform/BusinessAssociateFormScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/business-associates/$baId/edit')({
  beforeLoad: () => {
    requirePermission('ba:update');
  },
  component: BusinessAssociateEditRoute,
  staticData: { crumb: 'Edit' },
});

function BusinessAssociateEditRoute() {
  const { baId } = useParams({
    from: '/_staff/admin/platform/business-associates/$baId/edit',
  });
  return <BusinessAssociateEditScreen baId={baId} />;
}
